<app-loading-bar [isLoading]="loading$ | async"></app-loading-bar>
<router-outlet>
</router-outlet>